import { useMemo } from 'react';
import FinOpsVisualizerGraph from '@root/pages/finops/FinOpsVisualizerGraph';
import { mapFindingPathGraph } from './findingGraphMapper';

// How the CVE reaches the workload, drawn by the FinOps Visualizer graph (dotted grid, zoom controls,
// links that turn red on hover) from the finding's own path. Opens at 100% rather than the graph's default 120%.
const FindingPathGraph = ({ path, severity }) => {
  const data = useMemo(() => ({ path, severity }), [path, severity]);

  return (
    <div className="FindingPathGraph">
      <FinOpsVisualizerGraph data={data} mapData={mapFindingPathGraph} defaultZoomLevel={1} />
    </div>
  );
};

export default FindingPathGraph;
